import React, { FC } from "react";

const LoadingSpinner: FC = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      data-testid="loading-spinner"
    >
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
    </div>
  );
};

export default LoadingSpinner;
